<template>
  <div class="main">
    <div class="title">正式版</div>
    <div class="topCont">
      <div class="searchs">
        <el-input placeholder="请输入分享人手机号" v-model="keyWords" class="input-with-select" clearable>
          <el-button slot="append" icon="el-icon-search" @click="searchData"></el-button>
        </el-input>
      </div>
      <div class="count">昨日数量：{{ yesterdayData }}</div>
      <div class="count">累计数量：{{ page.total }}</div>
    </div>
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="customerName" label="客户姓名">
      </el-table-column>
      <el-table-column prop="customerPhone" label="客户联系方式">
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间">
      </el-table-column>
      <el-table-column prop="sharerPhone" label="分享人电话">
      </el-table-column>
      <el-table-column prop="projectManager" label="项目经理">
      </el-table-column>
      <el-table-column prop="projectName" label="项目名称">
      </el-table-column>
      <el-table-column prop="customerSatisfaction" label="整体满意度">
      </el-table-column>
      <el-table-column label="操作" align="center" width="150">
        <template slot-scope="scope">
          <div class="btn" @click="getDetailPdf(scope.row)"><i class="el-icon-view"></i>查看</div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page.pageNum"
      :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
    </el-pagination>
    <el-dialog class="ts_c" title="问卷预览" :visible.sync="dialogVisible" width="60%" append-to-body>
      <satisfaction :enterData="enterData" ref="satisfaction" />
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="success" @click="$refs.satisfaction.handlePrint()">打印</el-button>
        <el-button size="small" type="primary" @click="$refs.satisfaction.getPdf()">下载</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { querySurvey, submitCounter } from "@/api/home.js";
import satisfaction from "@/components/satisfaction.vue";
import changeImgDialogVue from '../components/changeImgDialog.vue';

export default {
  name: "feedback",
  components: {
    satisfaction
  },
  data() {
    return {
      page: {
        pageSize: 10,// 每页显示条数
        pageNum: 1,// 页码
        total: 0,// 页码
      },
      tableData: [],
      dialogVisible: false, // 弹框
      enterData: {},
      keyWords: '',
      yesterdayData: 0,
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    searchData() {
      this.getList()
    },
    getDetailPdf(row) {
      this.enterData = row
      this.dialogVisible = true
    },
    onSave() { },
    getList() {
      querySurvey({
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
        sharerPhone: this.keyWords
      }).then(res => {
        if (res.code == 200) {
          this.tableData = res.data.records
          this.page.total = res.data.total
        }
      })
      submitCounter().then(res => {
        if (res.code == 200) {
          this.yesterdayData = res.data
        }
      })
    },
    handleSizeChange(page) {
      this.page.pageSize = page;
      this.getList(this.page);
    },
    handleCurrentChange(page) {
      this.page.pageNum = page;
      this.getList(this.page);
    },
  },
};
</script>

<style lang="scss" sc>
.main {
  padding: 20px;

  .el-table {
    max-height: 800px;
    overflow-y: auto;
  }

  .el-pagination {
    text-align: right;
    margin-top: 20px;
  }
}

.title {
  font-size: 20px;
}

.btn {
  color: #409eff;
  cursor: pointer;
  font-size: 15px;

  i {
    font-size: 15px;
    padding: 0 5px;
  }
}

.topCont {
  display: flex;
  align-items: center;

  .count {
    font-size: 16px;
    margin-left: 20px;
    vertical-align: bottom;
  }
}

.searchs {
  width: 500px;
  margin: 20px 0;
}
</style>